import { IPSpinner, IPSpinnerSize, IPText } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { globalStackTokensGapSmall } from 'globalStyles';
import { useTranslation } from 'react-i18next';

interface IFrameworkAuditRunningIndicatorProps {
  running: boolean;
}

// Marks a framework whose AI audit is running right now. Deliberately small and text-only: the run is
// unattended and can take a long time, so the surfaces it appears on stay usable while it runs.
const FrameworkAuditRunningIndicator = (props: IFrameworkAuditRunningIndicatorProps) => {
  const { t } = useTranslation(['norms']);

  if (!props.running) return null;

  return (
    <IPStack horizontal verticalAlign="center" tokens={globalStackTokensGapSmall}>
      <IPStack.Item disableShrink>
        <IPSpinner size={IPSpinnerSize.xSmall} />
      </IPStack.Item>
      <IPStack.Item>
        <IPText variant="small">{t('norms:FrameworkAudit.Running')}</IPText>
      </IPStack.Item>
    </IPStack>
  );
};

export default FrameworkAuditRunningIndicator;
